import { Dinero } from 'dinero.js'
import shortUUID from 'short-uuid'

export enum GiftVoucherActivityType {
    SOLD = 'SOLD',
    REDEEMED = 'REDEEMED',
}

export class GiftVoucherActivityReportData {

    constructor(
        public activityType: GiftVoucherActivityType,
        public activityDate: Date,
        public giftedVoucherId: string,
        public lineItemId: string,
        public shortCode: string | null,
        public voucherName: string,
        public venueId: string,
        public venueDisplayName: string,
        public currencyCode: string,
        public voucherValue: Dinero,
        public merchantSalesValue: Dinero | null
    ) { }

    get voucherCode(): string {
        if (this.shortCode) {
            return this.shortCode.toUpperCase()
        }
        const translator = shortUUID()
        const base58Id = translator.fromUUID(this.giftedVoucherId)
        return base58Id.toUpperCase()
    }
}
